import { ImportWizard } from "@/shared/components/ImportWizard";
import { 
  v1InventoryStockReceiptsImportTemplateRetrieve,
  v1InventoryStockReceiptsImportDetectHeadersCreate,
  v1InventoryStockReceiptsImportValidateCreate,
  v1InventoryStockReceiptsImportCommitCreate,
  v1InventoryStockReceiptsImportBatchesRetrieve
} from "@/api/generated/v1/v1";

import { useNavigate } from "react-router-dom";
import { PageBanner } from "@/shared/components/PageBanner";

export function StockReceiptImportPage() {
  const navigate = useNavigate();
  const handleDownloadTemplate = async () => {
    try {
      const res = await v1InventoryStockReceiptsImportTemplateRetrieve();
      const blob = res instanceof Blob ? res : new Blob([res as unknown as BlobPart]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "stock_receipts_template.xlsx");
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (err) {
      console.error("Failed to download template", err);
    }
  };

  const handleDetectHeaders = async (file: File) => {
    const res = await v1InventoryStockReceiptsImportDetectHeadersCreate({ file });
    return res as any;
  };

  const handleValidate = async (data: { upload_token: string; column_mapping: any }) => {
    const res = await v1InventoryStockReceiptsImportValidateCreate(data);
    return res as any;
  };

  const handleCommit = async (data: { batch_id: string; row_selection: string }) => {
    const res = await v1InventoryStockReceiptsImportCommitCreate(data);
    return res as any;
  };

  const handleCheckStatus = async (batchId: string) => {
    const res = await v1InventoryStockReceiptsImportBatchesRetrieve(batchId);
    return res as any;
  };

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="ایمپورت رسید انبار (Stock Receipts)"
        subtitle="ورود گروهی اسناد انبار از طریق فایل Excel"
        icon="📥"
        helpLink="/help/inventory/stock-receipt-import"
      >
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          <button
            onClick={() => navigate("/inventory/stock")}
            style={{
              padding: "0.6rem 1rem",
              borderRadius: "12px",
              background: "rgba(255, 255, 255, 0.15)",
              color: "#ffffff",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              fontWeight: 700,
              fontSize: "0.85rem",
              cursor: "pointer",
            }}
          >
            ← بازگشت
          </button>
        </div>
      </PageBanner>

      <div className="brand-card-extand" style={{ maxWidth: "1000px", margin: "0 auto", padding: "2rem", width: "100%" }}>
        <ImportWizard
          entityLabel="رسید انبار (Stock Receipts)"
          onDownloadTemplate={handleDownloadTemplate}
          onDetectHeaders={handleDetectHeaders}
          onValidate={handleValidate}
          onCommit={handleCommit}
          onCheckStatus={handleCheckStatus}
        />
      </div>
    </div>
  );
}
